var render = function () {
  var _vm$value, _vm$value2, _vm$value2$entrance, _ref, _ref$toDateTime, _vm$value3, _vm$value3$schedule, _vm$value4, _vm$value5, _vm$value5$createdAt, _vm$value5$createdAt$, _vm$value6, _vm$value6$_interview;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium text-truncate"
  }, [_vm._v(" " + _vm._s(((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.title) || "비대면 면접") + " ")]), _c('p', {
    staticClass: "page-text--sm grey-6--text mt-4"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 참여유형: " + _vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$entrance = _vm$value2.entrance) === null || _vm$value2$entrance === void 0 ? void 0 : _vm$value2$entrance.typeText) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" / ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 면접일: " + _vm._s((_ref = ((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$schedule = _vm$value3.schedule) === null || _vm$value3$schedule === void 0 ? void 0 : _vm$value3$schedule.at) || ((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : _vm$value4.createdAt)) === null || _ref === void 0 ? void 0 : (_ref$toDateTime = _ref.toDateTime) === null || _ref$toDateTime === void 0 ? void 0 : _ref$toDateTime.call(_ref)) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" / ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 생성일: " + _vm._s((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : (_vm$value5$createdAt = _vm$value5.createdAt) === null || _vm$value5$createdAt === void 0 ? void 0 : (_vm$value5$createdAt$ = _vm$value5$createdAt.toDateTime) === null || _vm$value5$createdAt$ === void 0 ? void 0 : _vm$value5$createdAt$.call(_vm$value5$createdAt)) + " ")])])], 1)], 1)]), _c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "9",
      "lg": "auto"
    }
  }, [_c('v-sheet', [_c('p', {
    staticClass: "page-text--sm grey-9--text mb-4"
  }, [_vm._v("인원")]), _c('h5', {
    staticClass: "page-text--lg font-weight-medium"
  }, [_vm._v(_vm._s((_vm$value6 = _vm.value) === null || _vm$value6 === void 0 ? void 0 : (_vm$value6$_interview = _vm$value6._interviewees) === null || _vm$value6$_interview === void 0 ? void 0 : _vm$value6$_interview.length) + "명")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "auto"
    }
  }, [_c('item-enter', _vm._b({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-lg-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("입장하기")])])];
      }
    }])
  }, 'item-enter', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-100px",
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('remove', _vm.value);
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소하기")])])], 1)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }